export const DASHBOARD_GROUPS = {
  compliance_specialist: 'Compliance Specialist',
  compliance_manager: 'Compliance Manager',
  property_manager: 'Property Manager',
  portfolio_manager: 'Portfolio Manager',
  company_manager: 'Company Manager',
  pronto_admin: 'Pronto Admin',
  bulk_communications: 'Bulk Communications',
  team_renters_bulk_actions: 'Team Renters Bulk Actions',
};
